import { $, _ } from 'wgnet-awesomejs';
import BaseInput from 'source/lib/component/input/base';
import Settings from 'source/lib/settings_model';
import messages from 'messages';

import template from './template.html';
import hint from './hint_content.html';

const LoginInput = BaseInput.extend({
    name: 'login-input',
    template,
    bindHint() {
        this.$hint = $('.js-form-field-hint');
        this.$hintPhone = $('.js-description-field');
        this.$hintContent = this.$('.js-form-field-description-content');

        this.events['focus input'] = 'showHint';
        this.events['blur input'] = 'hideHint';
    },
    showHint() {
        const state = this.$hint.data('current-state');
        if (state === 'error') {
            this.$hint.show();
        }

        this.setHintContent();
        this.$hintPhone.show();
        this.$hintContent.show();
    },
    hideHint() {
        this.$hint.hide();
        this.$hintPhone.hide();
        this.$hintContent.hide();
    },
    setHint(state, rendered) {
        this.$hint.data('current-state', state);
        this.$hintContent.html(rendered);
    },

    setHintContent() {
        const state = this.$hint.data('current-state');

        if (state !== 'error') {
            this.$hintContent.text(messages.texts.email_phone_login.general_hint);
        }
    },

    initialize(args = {}) {
        const loginByPhoneEnabled = Settings.get('Authentication.LoginByPhoneEnabled');
        let loginByPhoneLgc = false;
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('auth_type') === 'basic') {
            loginByPhoneLgc = true;
        }
        let placeholder;

        if (loginByPhoneEnabled) {
            placeholder = loginByPhoneLgc
                ? messages.texts.login_input_placeholder.placeholder_email_phone_lgc
                : messages.texts.login_input_placeholder.placeholder_email_phone;
        } else {
            placeholder = messages.texts.login_input_placeholder.placeholder_email;
        }

        BaseInput.prototype.initialize.call(this, Object.assign(
            args,
            {
                loginByPhoneEnabled,
                placeholder,
            }
        ));

        this.bindHint();

        this.delegateEvents();
        this.$root.on('component:all:login-validated', this.onValidated.bind(this));
    },
    keyup(event = {}) {
        BaseInput.prototype.keyup.call(this, event);
        if (Settings.get('Request.BadEmailDomains', []).length > 0) {
            this.components.proxyEvent('check', event, this);
        }
        this.setHintContent();
    },
    getMessage(message) {
        return _.extract(messages, `errors.login.${message}`);
    },
    onValidated(event, { result }) {
        const loginError = _.extract(result, 'responseJSON.errors.login', [])[0];
        const message = this.getMessage(loginError);
        if (message) {
            this.setHint('error', hint({
                error: message,
            }));
            this.showHint();
            this.isErrored = true;
        } else {
            this.isErrored = false;
            this.setHint('no-hint', hint({}));

            if (!this.$el.find('input').is(':focus')) {
                this.hideHint();
            }
        }
    },
});

export default LoginInput;
